export default "__VITE_ASSET__e2jOh_7Q__"